import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, ToastController } from 'ionic-angular';
import { Task } from '../../model/model';

@IonicPage()
@Component({
  selector: 'page-edit-task',
  templateUrl: 'edit-task.html',
})

export class EditTaskPage {

  tasks: any = {} as Task;
  task: Task;
  index: number = 0;
  changed: string = 'false';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController
  ) {
    if (localStorage.getItem('tasks')) {
      this.tasks = JSON.parse(localStorage.getItem('tasks'));
    }
    this.index = this.navParams.get('index');
    this.task = this.tasks[this.index];
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  saveTask() {
    this.tasks[this.index] = this.task;
    localStorage.setItem('tasks', JSON.stringify(this.tasks));
    this.dismiss();
    const toast = this.toastCtrl.create({
      message: 'Save Completed.',
      duration: 2500
    });
    toast.present();
  }

  checkChange() {
    this.changed = 'true';
  }
}



// WEBPACK FOOTER //
// ./src/pages/edit-task/edit-task.ts